import { useEffect, useState } from "react";
import "./index.css";
import { Button, Checkbox } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  cloudKeyList,
  encryptCloudKeys,
  rotateCloudKeys,
} from "../../../../redux/features/byok/byok";
import Loader from "../../../Loader/Index";
import TEXT from "../../../../utils/globalText";
import TextInputField from "../../../_utils/CommonInputFields/TextInputField";
import PrimaryButton from "../../../_utils/CommonButtons/PrimaryButton";
import ICONS from "../../../../assets/Icons";

const BYOKEncryptconfirmationPopup = ({
  openEncryptConfPopup,
  setOpenEncryptConfPopup,
  selectKey,
  setCurrentDisplay,
  setCanEncrypt,
  setIsBYOKEncProcessing,
  encryptCloudKeysLoading,
  isRotatingKeys,
  setisRotatingKeys,
  setCurrentFetchedKey,
  rotateKeysGetLoading,
  setIsChangeKeyFlowComplted,
  setIsEncryptDone,
}) => {
  const [inputText, setInputText] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  const [timeOutSD, setTimeOutSD] = useState(false);

  const dispatch = useDispatch();

  const enableConfirm = inputText === "Yes, proceed";
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && enableConfirm) {
        handleEncryption();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [enableConfirm]);

  const handleEncryption = async () => {
    try {
      setTimeOutSD(true);
      if (isRotatingKeys) {
        const response = await dispatch(rotateCloudKeys(selectKey));

        const message = response.payload.message;

        //: in updated keys, we have to show Key has been updated instead of "data encrypted sucessfully"
        if (message === "Key Rotation Queued successfully.") {
          setTimeout(() => {
            setOpenEncryptConfPopup(false);
            setCurrentDisplay("ByokDashboardPage");
            // CommonToast({
            //   text: "Key has been updated",
            //   icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            //   variant: "var(--success)",
            //   btnProps: {
            //     isDisabled: false,
            //     enabledTextColor: "var(--text-primary)",
            //     enabledBgColor: "var(--primary-bg)",
            //   },
            // });
            setIsBYOKEncProcessing(true);
            setCanEncrypt(true);
            setisRotatingKeys(false);
            setTimeOutSD(false);
          }, 3000);
          setIsChangeKeyFlowComplted(true);
        }
      } else {
        const response = await dispatch(encryptCloudKeys(selectKey));

        const message = response.payload.message;

        if (
          message === "Encryption Queued successfully." ||
          "Data is already encrypted" ||
          "Encryption process is on going"
        ) {
          const keysResponse = await dispatch(
            cloudKeyList({ showToast: false }),
          );

          if (keysResponse?.payload?.encryption_key) {
            setCurrentFetchedKey(keysResponse?.payload?.encryption_key);
          }

          setTimeout(() => {
            setOpenEncryptConfPopup(false);
            setCurrentDisplay("ByokDashboardPage");
            setIsBYOKEncProcessing(true);
            setCanEncrypt(true);
            setTimeOutSD(false);
            setIsEncryptDone(true);
          }, 3000);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={`byok-encryp-conf-popup ${
        openEncryptConfPopup ? "popup-show" : ""
      }`}
    >
      <div className="flex flex-col gap-gap-md w-full">
        <div className="flex flex-col gap-gap-sm">
          <div className="flex flex-row gap-gap-sm items-center">
            <img
              src="https://q2pay.in/new_assets/common/dashboard/alert.svg"
              className="w-icon-md h-icon-md"
              alt="alert-img"
            />
            <p className="text-error text-font-lg font-semibold">
              {TEXT?.ALERT}
            </p>
          </div>
          <div className="flex flex-col gap-gap-sm">
            <p className="text-text-primary text-font-md font-normal">
              Once the process starts,{" "}
              <span className="text-failed">it cannot be aborted.</span>
            </p>

            <p className="text-text-secondary text-font-sm font-normal">
              {TEXT?.COMPLETION_TIME_NOTICE}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-gap-md">
          <p className="text-font-md font-normal text-text-primary">
            To confirm, kindly type{" "}
            <strong className="tracking-letter-space">“Yes, proceed”</strong> in
            the input field below.
          </p>
          <div className="w-full">
            <TextInputField
              variant={enableConfirm ? "verified" : "default"}
              placeholder={"Enter text"}
              fontKind={"big"}
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              value={inputText}
              name={"Entertext"}
              onInput={(e) => {
                setInputText(e.target.value);
              }}
              isFullWidth={true}
            />
          </div>
        </div>
        <div className="flex flex-row gap-gap-sm justify-end">
          {!timeOutSD && !rotateKeysGetLoading && (
            <PrimaryButton
              btnText={TEXT?.CHANGE_KEY_ID}
              btnType="button"
              handleFunction={() => {
                setOpenEncryptConfPopup(false);
                setInputText("");
                setIsFocus(false);
              }}
              // isDisabled={!enableConfirm}
              enabledBgColor="var(--primary-card)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
              outLineColor={"var(--text-primary)"}
            />
          )}
          {timeOutSD || rotateKeysGetLoading ? (
            <Loader height="var(--loader-md)" />
          ) : (
            <PrimaryButton
              btnText={TEXT?.START_PROCESS}
              btnType="button"
              handleFunction={handleEncryption}
              isDisabled={!enableConfirm}
              enabledBgColor="var(--Button-green)"
              disabledBgColor="var(--text-secondary)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
            />
          )}
        </div>
      </div>
    </div>
  );
};
const SelectKeyId = ({
  selectKey,
  setSelectKey,
  cloudKeyListLoading,
  cloudKeyListData,
  cloudKeyListError,
  bankingSelected,
  setBankingSelected,
  openEncryptConfPopup,
  setOpenEncryptConfPopup,
  setCurrentDisplay,
  setCanEncrypt,
  setIsBYOKEncProcessing,
  encryptCloudKeysLoading,
  showMsg,
  setShowMsg,
  isRotatingKeys,
  setisRotatingKeys,
  currentFetchedKey,
  setCurrentFetchedKey,
  rotateKeysGetLoading,
  isChangeKeyFlowStarted,
  isChangeKeyFlowComplted,
  setIsChangeKeyFlowComplted,
  setIsEncryptDone,
}) => {
  const [showMgsDiv, setShowMgsDiv] = useState(false);
  const [isIpad, setIsIpad] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsIpad(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
    // Later on can be use this
    // className={`flex Qlg:w-max-content-width w-full bg-primary-bg Qlg:flex-row flex-col ${
    //   !isIpad && showMsg ? "h-screen" : "h-auto"
    // }`}
    >
      <div style={{ zIndex: !openEncryptConfPopup && "var(--z-index-header)" }}>
        {openEncryptConfPopup && (
          <div
            className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal "
            style={{
              backgroundColor: "var(--PopUp-BackDrop)",
              opacity: "var(--dark-opacity)",
            }}
          ></div>
        )}
        <BYOKEncryptconfirmationPopup
          openEncryptConfPopup={openEncryptConfPopup}
          setOpenEncryptConfPopup={() => setOpenEncryptConfPopup(false)}
          selectKey={selectKey}
          setCurrentDisplay={setCurrentDisplay}
          setCanEncrypt={setCanEncrypt}
          setIsBYOKEncProcessing={setIsBYOKEncProcessing}
          // setCurrentDisplay={setCurrentDisplay}
          // byokProcessPending={byokProcessPending}
          // byokProcessFailed={byokProcessFailed}
          encryptCloudKeysLoading={encryptCloudKeysLoading}
          isRotatingKeys={isRotatingKeys}
          setisRotatingKeys={setisRotatingKeys}
          setCurrentFetchedKey={setCurrentFetchedKey}
          isChangeKeyFlowStarted={isChangeKeyFlowStarted}
          isChangeKeyFlowComplted={isChangeKeyFlowComplted}
          setIsChangeKeyFlowComplted={setIsChangeKeyFlowComplted}
          setIsEncryptDone={setIsEncryptDone}
        />
      </div>

      <div className="w-full flex Qlg:flex-row flex-col Qlg:gap-gap-xl gap-gap-md pt-padding-md pb-[var(--mobile-create-header)]">
        <div
          className="flex-1"
          // style={{ zIndex: !openEncryptConfPopup && "var(--z-index-header)" }}
        >
          <div className="bg-primary-card p-padding-md rounded-border-radius-md flex flex-col gap-gap-md">
            <div className="flex flex-col gap-gap-xs">
              <h2 className="text-text-primary text-font-md font-semibold">
                {TEXT?.FETCHED_KEY_IDS}
              </h2>
              <p className="text-text-secondary text-font-xs font-normal">
                {TEXT?.SELECT_KEY_ID_TO_ENCRYPT}
              </p>
            </div>

            <div className="custom-scroll-container pr-padding-md flex flex-col gap-gap-sm h-multientity-header-height  overflow-y-auto">
              {cloudKeyListData?.keys?.map((val, i) => {
                return (
                  <Button
                    key={i}
                    size="small"
                    sx={{
                      "display": "flex",
                      "justifyContent": "space-between",
                      "pointerEvents": "auto",
                      "alignItems": "center",
                      "backgroundColor":
                        val === selectKey
                          ? "var(--Category-selection)"
                          : "var(--Filter-chip-outline-stroke)",

                      "&:hover": {
                        backgroundColor:
                          val === selectKey
                            ? "var(--Category-selection-hover)"
                            : "var(--Filter-chip-outline-stroke)",
                      },
                      "borderRadius": "var(--border-radius-sm)",
                      "padding": "var(--padding-sm)",
                      "height": "var(--height-of-statistics-tab-line)",
                      "width": "var(--width-full)",
                    }}
                    onClick={() => {
                      if (val === selectKey && selectKey?.length !== 0) {
                        setSelectKey("");
                      } else {
                        setSelectKey(val);
                      }
                    }}
                  >
                    <span className="byok_keysID"> {val}</span>
                    <div>
                      <Checkbox
                        icon={
                          <img
                            className="w-icon-sm h-icon-sm"
                            src={
                              "https://q2pay.in/new_assets/common/create_flow/radio_button_not_selected.svg"
                            }
                            alt=""
                          />
                        }
                        checkedIcon={
                          <img
                            className="w-icon-sm h-icon-sm"
                            src={
                              "https://q2pay.in/new_assets/common/create_flow/radio_button_selected.svg"
                            }
                            alt=""
                          />
                        }
                        className="radioBT"
                        checked={val === selectKey}
                      />
                    </div>
                  </Button>
                );
              })}
            </div>
          </div>
        </div>

        <div
          className="flex-1"
          // style={{ zIndex: !openEncryptConfPopup && "var(--z-index-header)" }}
        >
          <div className=" bg-primary-card p-padding-md rounded-border-radius-md">
            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col gap-gap-sm">
                <h2 className="text-text-primary text-font-md font-semibold">
                  {TEXT?.ENCRYPT_DATA}
                </h2>
                <p className="text-text-secondary text-font-xs font-normal">
                  {TEXT?.SELECT_CREDENTIALS_TO_ENCRYPT}
                </p>
              </div>
              <Button
                size="small"
                onClick={() => {
                  setBankingSelected(!bankingSelected);
                }}
                sx={{
                  "display": "flex",
                  "alignItems": "center",
                  "justifyContent": "flex-start",
                  "gap": "var(--gap-sm)",
                  "backgroundColor": bankingSelected
                    ? "var(--Category-selection)"
                    : "var( --Filter-chip-outline-stroke)",
                  "&:hover": {
                    backgroundColor: bankingSelected
                      ? "var(--Category-selection-hover)"
                      : "var(--Filter-chip-outline-stroke)",
                  },
                  "borderRadius": "var(--border-radius-sm)",
                  "color": "var(--text-primary)",
                  "height": "var(--dropdown-option-height-md)",
                  "padding": "var(--padd)",
                  "fontSize": "var(--font-sm)",
                  "cursor": "pointer",
                  "width": "var(--width-full)",
                }}
              >
                <div
                  style={{
                    alignSelf: "center",
                    marginLeft: "var(--margin-md)",
                  }}
                >
                  <img
                    className="w-icon-sm h-icon-sm"
                    src={
                      bankingSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.NOTSELECTED_WITH_GREY_CIRCLE
                    }
                    alt=""
                  />
                </div>
                <span className="byok_checkbox">
                  {TEXT?.BANKING_CREDENTIALS}
                </span>
              </Button>

              <div className="flex gap-gap-md">
                <div className="byok-note-section">
                  <p className="byok_note">
                    {TEXT?.BANKING_CREDENTIALS_ENCRYPTION_NOTE}
                  </p>
                  <div className="flex gap-gap-sm items-center">
                    <img
                      src={
                        "https://q2pay.in/new_assets/common/detail_page/info.svg"
                      }
                      className="w-icon-sm h-icon-sm cursor-pointer"
                      alt=""
                    />
                    <div className="relative">
                      <div
                        className="why-banking-heading"
                        onMouseEnter={() => {
                          setShowMsg(true);
                        }}
                        onMouseLeave={() => {
                          setShowMsg(false);
                        }}
                        onClick={() => {
                          if (isIpad) {
                            setShowMgsDiv(!showMgsDiv);
                          }
                        }}
                      >
                        {TEXT?.WHY_BANKING_DATA_RESTRICTED}
                      </div>
                      <div
                        className="why-banking-heading-msg"
                        style={{
                          display: showMsg && !isIpad ? "block" : "none",
                        }}
                      >
                        <p className="font-normal text-font-sm text-text-primary">
                          {TEXT?.BANKING_CREDENTIALS_ENCRYPTION_INFO}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <img
                    src={
                      "https://q2pay.in/new_assets/graphics/byok/encrypt_data.svg"
                    }
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="why-only-banking-mobile"
            style={{
              display: showMgsDiv && isIpad ? "block" : "none",
            }}
          >
            <p className="font-normal text-font-sm text-text-primary">
              {TEXT?.BANKING_CREDENTIALS_ENCRYPTION_INFO}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectKeyId;
